import React from "react";
import Modal from "../index";
import {FlexContainer, Img, Text} from "../../../design";
import success from "../../../assets/imgs/success.svg";

type Props = {
  isOpen: boolean,
  partnerConnection: Boolean,
  successMsg: String,
  processing: Boolean,
  accountId: String,
  paymentId: String,
  autopayMessage: String,
  message: String,
  pauseType: String,
}
const SuccessModal = (props : Props) => {
  return (
    <Modal isOpen={props.isOpen}>
        <FlexContainer
            height="400px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            box-shadow="0 0 20px 0 rgba(0, 0, 0, 0.1)"
            backdropFilter='none'
            borderRadius='4px'
            backgroundColor="#f2f5f8"
            textAlign='center'
            alignContent='none'
        >
            <Img width='108px' height='108px' paddingBottom='25px' src={success} />
            <Text
                fontSize="20px"
                fontWeight='600'
            >
              {
                props.message ? (
                  <>{props.message}</>
                ) : (
                  <>
                  {props.successMsg ? props.successMsg : (props.partnerConnection ? 'Partner Connection Completed' : (props.processing ? 'Payment placed successfully in the process': 'Transaction Complete'))}
                  </>
                )
              }
            </Text>
            {
              props.message ? (
                <Text fontSize="16px" textAlign="center" paddingX="14px">{props.pauseType}</Text>
              ) : (
                <Text fontSize="16px" textAlign="center" paddingX="14px">
                {(props?.accountId === 'account-7f724541b3f94eeebe942019ae5f2dfa' && props?.paymentId === 'paymentpagelink-9738c23d82914b93ba199e29e9fce009')
                ?  (<>
                Please look for an email from{" "}
                <a href="mailto:support@swirepay.com" color="blue.500">
                  support@swirepay.com
                </a>{" "}
                for payment confirmation and tickets.
              </>)
                : ('You will be redirected automatically.')}
            </Text>
              )
            }
            
            {props?.autopayMessage && 
              <Text fontSize="16px" textAlign="center" paddingX="14px">
                Thank you for opting Autopay
              </Text>
            }
        </FlexContainer>
    </Modal>
  )
};

export default SuccessModal;
